import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from "axios"
import request from './utils/request'
import VueClipboard from 'vue-clipboard2'
import 'vant/lib/index.css'
import { appInfo } from './utils/appEnv'

// 引入Vant组件
import { 
  NavBar, Image as VanImage, Badge, Icon, Tab, Tabs, 
  Skeleton, Empty, Popup, Grid, GridItem, Dialog, 
  Button, DropdownMenu, DropdownItem, Toast,
  Cascader, Search, SubmitBar, ImagePreview
} from 'vant'

// 注册Vant组件
Vue.use(NavBar).use(VanImage).use(Badge).use(Icon)
  .use(Tab).use(Tabs).use(Skeleton).use(Empty)
  .use(Popup).use(Grid).use(GridItem).use(Dialog)
  .use(Button).use(DropdownMenu).use(DropdownItem).use(Toast)
  .use(Cascader).use(Search).use(SubmitBar).use(ImagePreview)

Vue.use(VueClipboard)

Vue.config.productionTip = false
Vue.prototype.$axios = axios // 使用默认axios
Vue.prototype.$request = request // 使用封装的请求实例
Vue.prototype.$toast = Toast // 添加toast方法
// 电竞助手 App 内嵌时已有原生导航栏，页面自带的 van-nav-bar 隐藏；$app 提供版本/平台/渠道等细粒度信息。
Vue.prototype.$app = appInfo
Vue.prototype.$inApp = appInfo !== null

// 百度统计代码
var _hmt = _hmt || [];
(function () {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?bfd885c00202d5ee2c3ca5a001f049b9";
  var s = document.getElementsByTagName("script")[0];
  s.parentNode.insertBefore(hm, s);
})();

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

